import script from "./RecentActions.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentActions.vue?vue&type=script&setup=true&lang=js"

import "./RecentActions.vue?vue&type=style&index=0&id=663c9424&scoped=true&lang=css"
import "./RecentActions.vue?vue&type=style&index=1&id=663c9424&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-663c9424"]])

export default __exports__